import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, Input } from '@angular/core';
import {  ModalController } from '@ionic/angular';

import { Payment } from '../../../models/payment/payment.model';
import { Sale } from '../../../models/sale/sale.model';
import { List } from 'immutable';
import { SalonService } from '../../../services/'

@Component({
  selector: 'app-sale-payment-picker',
  templateUrl: './sale-payment-picker.page.html',
  styleUrls: ['./sale-payment-picker.page.scss'],
})
export class SalePaymentPickerPage implements OnInit {

  public paymentTypes: List<Payment> = List([]);
  public dismissSetupFooter: boolean = false;

  @Input() disableCashButton: boolean;

  constructor (
      //private viewCtrl: ViewController,
      //private navParams: NavParams,
      private changeDetectorRef: ChangeDetectorRef,
      private modalCtrl: ModalController,
      private salonService: SalonService) {
        // this.paymentTypes = Sale.getPaymentTypes();
   // this.disableCashButton = this.navParams.get('disableCashButton');
  }

  public ngOnInit () {
    let dismissSetupFooterObj = JSON.parse(localStorage.getItem("dismissSetupFooterObj"));
    if (dismissSetupFooterObj && new Date().getTime() > dismissSetupFooterObj?.expired) {
      let dismissSetupFooterObj = {
        dismissSetupFooter: "false",
        expired: new Date((new Date()).setDate((new Date()).getDate() + 60))
      }
      localStorage.setItem("dismissSetupFooterObj", JSON.stringify(dismissSetupFooterObj));
      this.dismissSetupFooter = false;
    } else {
      this.dismissSetupFooter = dismissSetupFooterObj?.dismissSetupFooter == "true";
    }
    this.salonService.getSalonPaymentTypes().subscribe((paymentTypes)=> {
      if (paymentTypes.cash === 1) {
        this.paymentTypes = this.paymentTypes.push(new Payment({ type: 1, name: 'Cash', amount: 0 }))
      }
      if (paymentTypes.debit === 1) {
        this.paymentTypes = this.paymentTypes.push(new Payment({ type: 2, name: 'Debit', amount: 0 }))
      }
      if (paymentTypes.visa === 1) {
        this.paymentTypes = this.paymentTypes.push(new Payment({ type: 3, name: 'Visa', amount: 0 }))
      }
      if (paymentTypes.mastercard === 1) {
        this.paymentTypes = this.paymentTypes.push(new Payment({ type: 4, name: 'MasterCard', amount: 0 }))
      }
      if (paymentTypes.amex === 1) {
        this.paymentTypes = this.paymentTypes.push(new Payment({ type: 5, name: 'AMEX', amount: 0 }))
      }
      if (paymentTypes.cheque === 1) {
        this.paymentTypes = this.paymentTypes.push(new Payment({ type: 6, name: 'Check/Cheque', amount: 0 }))
      }
      if (paymentTypes.giftcard === 1) {
        this.paymentTypes = this.paymentTypes.push(new Payment({ type: 7, name: 'Giftcard', amount: 0 }))
      }
      if (paymentTypes.etransfer === 1) {
        this.paymentTypes = this.paymentTypes.push(new Payment({ type: 8, name: 'e-Transfer', amount: 0 }))
      }
      if (paymentTypes.discover === 1) {
        this.paymentTypes = this.paymentTypes.push(new Payment({ type: 9, name: 'Discover', amount: 0 }))
      }
      if (paymentTypes.account === 1) {
        this.paymentTypes = this.paymentTypes.push(new Payment({ type: 10, name: 'Account', amount: 0 }))
      }
      if (paymentTypes.square === 1) {
        this.paymentTypes = this.paymentTypes.push(new Payment({ type: 11, name: 'Square', amount: 0 }))
      }
    })
  }

  public onDismiss () {
    //this.viewCtrl.dismiss();
    this.modalCtrl.dismiss();   
  }

  public onPaymentSelect (payment: Payment) {
    //this.viewCtrl.dismiss(payment);
    const data = {
      payment: payment,
      action: 'save',
      cashRounding: 0,
      otherPayment: true
    };
    this.modalCtrl.dismiss(data);   
  }

  public dismissSetup(){
    this.dismissSetupFooter = true;
    let dismissSetupFooterObj = {
      dismissSetupFooter: "true",
      expired: new Date((new Date()).setDate((new Date()).getDate() + 60)).getTime()
    }
    localStorage.setItem("dismissSetupFooterObj", JSON.stringify(dismissSetupFooterObj));
  }
}
